import BigNumber from 'bignumber.js'
import nftLaunchpadFactoryABI from 'config/abi/nftLaunchpadFactory.json'
import nftLaunchpadFactoryV2ABI from 'config/abi/nftLaunchpadFactoryV2.json'
import { multicallWithAbi } from 'utils/multicall'
import { getNftLaunchpadFactoryAddress, getNftLaunchpadFactoryV2Address } from 'utils/addressHelpers'

const fetchLaunchpadOnlyWhitelisted = async () => {
  const calls = [
    {
      address: getNftLaunchpadFactoryAddress(),
      name: 'onlyWhitelisted',
      abi: nftLaunchpadFactoryABI,
    },
    {
      address: getNftLaunchpadFactoryAddress(),
      name: 'owner',
      abi: nftLaunchpadFactoryABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'owner',
      abi: nftLaunchpadFactoryV2ABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'onlyWhitelisted',
      abi: nftLaunchpadFactoryV2ABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'onlyPayDMD',
      abi: nftLaunchpadFactoryV2ABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'onlyPayFTM',
      abi: nftLaunchpadFactoryV2ABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'feeFTM',
      abi: nftLaunchpadFactoryV2ABI,
    },
    {
      address: getNftLaunchpadFactoryV2Address(),
      name: 'amount',
      abi: nftLaunchpadFactoryV2ABI,
    },
  ]
  const [onlyWhitelistedFC, ownerFC, ownerV2FC, onlyWhitelistedV2FC, onlyPayDMDFC, onlyPayFTMFC, feeFTMFC, feeDMDFC] =
    await multicallWithAbi(calls)

  return {
    v1: {
      onlyWhitelisted: onlyWhitelistedFC[0],
      owner: ownerFC[0],
    },
    v2: {
      onlyWhitelisted: onlyWhitelistedV2FC[0],
      owner: ownerV2FC[0],
      onlyPayDMD: onlyPayDMDFC[0],
      onlyPayFTM: onlyPayFTMFC[0],
      feeFTM: new BigNumber(feeFTMFC[0]._hex),
      feeDMD: new BigNumber(feeDMDFC[0]._hex),
    },
  }
}

export default fetchLaunchpadOnlyWhitelisted
